import { breadcrumbAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(breadcrumbAnatomy.keys);

const baseStyle = definePartsStyle({
  list: {
    my: 6,
  },
  item: {
    color: 'neutral.fg-tertiary',
  },
  separator: {
    mx: 3,
    color: 'neutral.fg-disabled',
  },
});

export const styleConfig = defineMultiStyleConfig({
  baseStyle,
});
